import { render, staticRenderFns } from "./PopHowToSetPwa.vue?vue&type=template&id=6e424b6c&lang=pug"
import script from "./PopHowToSetPwa.vue?vue&type=script&lang=js"
export * from "./PopHowToSetPwa.vue?vue&type=script&lang=js"
import style0 from "./PopHowToSetPwa.vue?vue&type=style&index=0&id=6e424b6c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports